import React from "react";
import PaginatedTable from "../../sharedComponents/tableWithPagination";

export default function WeightHistoryTable({ weightHistoryList, getData, name }) {
	const columns = [
		{
			Header: "DATE",
			accessor: "start_date",
			width: 130
		},
		{
			Header: "WEIGHT",
			accessor: "weight",
			width: 100
		},
		{
			Header: "BMI",
			accessor: "bmi",
			width: 100
		},
		{
			Header: "BP",
			accessor: "bp",
			width: 100
		},
		{
			Header: "FAT",
			accessor: "fat",
			width: 100
		},
		{
			Header: "FAT MASS",
			accessor: "fat_mass",
			width: 130
		},
		{
			Header: "PULSE",
			accessor: "pulse",
			width: 100
		},
		{
			Header: "TBW",
			accessor: "tbw",
			width: 100
		},
		{
			Header: "W-DELTA",
			accessor: "w_delta",
			width: 130
		},
		{
			Header: "W-DELTA TOTAL",
			accessor: "w_delta_total",
			width: 150
		},
		{
			Header: "WAIST",
			accessor: "waist",
			width: 100
		}
	];

	return (
		<div className="card card-primary w-100 h-100 m-0 p-4 border-0 featured-recipes-list">
			<h4 className="text-primary-dark">{name}</h4>
			<div className="pt-3 last-child-b-0">
				<PaginatedTable
					data={weightHistoryList && weightHistoryList.results}
					columns={columns}
					totalItems={weightHistoryList && weightHistoryList.count}
					prev={weightHistoryList && weightHistoryList.previous}
					next={weightHistoryList && weightHistoryList.next}
					pageSize={20}
					onPagination={(e) => {
						getData(`?limit=20&${e}`);
					}}
				/>
			</div>
		</div>
	);
}
